import { useSelector } from 'react-redux';
import { getInstallableModules, getZone, getZoneModules } from '../redux/selectors/zones';
import useGruser from './useGruser';
import ZoneContext from '../context/ZoneContext/ZoneContext';
import { useContext } from 'react';
export const useZone = (zoneName)=>{
    const { gruser } = useGruser();
    return useSelector((state)=>getZone(state, gruser, zoneName));
};
export const useCurrentZoneName = ()=>{
    var _useContext;
    return (_useContext = useContext(ZoneContext)) === null || _useContext === void 0 ? void 0 : _useContext.name;
};
export const useZoneModules = (zoneName)=>{
    const { gruser } = useGruser();
    const installedModules = useSelector((state)=>getZoneModules(state, gruser, zoneName));
    const installableModules = useSelector((state)=>getInstallableModules(state, gruser, zoneName));
    return {
        installedModules,
        installableModules
    };
};
export const useModuleInstallableToZone = (zoneName, moduleName)=>{
    var _installableModuleTypes_find_restrict, _installableModuleTypes_find;
    const { installedModules } = useZoneModules(zoneName);
    const { installableModuleTypes } = useZone(zoneName);
    const installedCount = installedModules.filter((m)=>m.name === moduleName).length;
    const installableCount = ((_installableModuleTypes_find = installableModuleTypes.find((m)=>m.moduleName === moduleName)) === null || _installableModuleTypes_find === void 0 ? void 0 : (_installableModuleTypes_find_restrict = _installableModuleTypes_find.restrict) === null || _installableModuleTypes_find_restrict === void 0 ? void 0 : _installableModuleTypes_find_restrict.limit) || installedCount + 1;
    return installableCount > installedCount;
};
export default useZone;

//# sourceMappingURL=useZone.js.map